module.exports = __webpack_public_path__ + "static/media/epid-nav.8b34cb0b.png";